// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./wp-content/themes/internetmedia/dev/sass/vendors.scss
// module id = 16
// module chunks = 0